module.exports = __webpack_public_path__ + "img/aboutus-darren-image.933a74cd.png";